var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTonga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40.0001 31.0456 40.0001 19.9999C40.0001 8.95418 31.0457 -0.00012207 20 -0.00012207C8.95435 -0.00012207 4.57764e-05 8.95418 4.57764e-05 19.9999C4.57764e-05 31.0456 8.95435 39.9999 20 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0437 10.4346V7.82593H10.435V10.4346H7.82628V13.0433H10.435V15.652H13.0437V13.0433H15.6524V10.4346H13.0437Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 -0.00012207V19.9999C8.95462 20 4.5647 19.9999 0.000244141 20C0.000244141 31.0455 8.95462 39.9999 20.0002 39.9999C31.0459 39.9999 40.0002 31.0455 40.0002 19.9999C40.0002 8.95425 31.0459 -0.00012207 20.0002 -0.00012207Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonga);
export default __webpack_public_path__ + "static/media/tonga.c8dc391f8f24769745ba38deebf9a7c8.svg";
export { ForwardRef as ReactComponent };